/**
 * 充值档列表视图
 * @author zhenn
 * @time 2016-11-16
 */
import React, {Component} from 'react';
import url from 'c-url';
import lang from '../lang/index';
import global from '../global/global';
import Notification from '../global/notification';
import cache from '../global/cache';

import channelConfig,{switchChannel} from '../global/channel-config';
import Popup from '../popup/common-popup';
import IcardConfirmDialog from '../popup/icard-confirm';
import PaystackConfirmModal from './channels/paystack/confirm-modal';


import SslConfirmModal from './channels/ssl/confirm-modal';

class Item extends Component {

    static defaultProps = {
        data: {},
        onSelectPay(){}
    }

    btnClick(pid,itemData) {
        global.setSelectedOption(itemData);
        this.props.onSelectPay(pid);
    }

    render() {

        let props = this.props;
        let data = props.data;
        let description = data.description;
        let desc;

        if (data.type == 1) {
            desc = <em className="tip">{lang.template('每人仅限一次机会')}</em>;
        } else if (description) {
            if (description.match(/\d+/gi)) {
                let count = description.match(/\d+/gi)[0];
                desc = <em className="tip">{lang.template('已加赠<%=count%>U钻',{count: count})}</em>;
            } else {
                desc = <em className="tip">{description}</em>;
            }
        }

        return (
            <li>
                <icon></icon>
                <span className="num">{data.amount}</span>
                {desc}
                <button type="button" data-fee={data.money / 100} onClick={this.btnClick.bind(this, data.configId ,data)}>{data.currencySymbol}{data.money / 100}</button>
            </li>
        );
    }
}

class OptionListView extends Component {

    static defaultProps = {
        onSelectPay() {}
    };

    constructor(props) {
        super(props);

        this.state = {
            list: props.list,
            icardUD: 0
        };
    }

    componentWillReceiveProps(nextProps) {
        let icardUD = 0;

        if (url.query('channel') == 'icard') {
            if (nextProps.list.length > 0) {
                let [real, number] = nextProps.list[0].proportion.split(':');
                icardUD = 20000 * number / real;
            }
        }

        this.setState({
            list: nextProps.list,
            icardUD
        });
    }

    // ******************** Paystack payment start ***********************
    onPaystackConfirmed(extra) {
        const user = cache.getCache('userInfo');
        const pars = {
            name: user.upliveCode,
            email: extra.email
        };
        this.setState({ extra: pars });
    }

    onPaystackSelectPay(key) {
        this.props.onSelectPay(key, this.state.extra);
    }

    // ******************** Paystack payment end ***********************

    // ******************** SSL payment start ***********************
    onSslConfirmed(extra) {
        const user = cache.getCache('userInfo');
        const pars = {
            name: user.upliveCode,
            email: extra.email,
            phone: extra.mobile
        };
        this.setState({ extra: pars });
    }

    onSslSelectPay(key) {
        this.props.onSelectPay(key, this.state.extra);
    }

    // ******************** SSL payment end ***********************

    // get the text content of selected option
    getSelectedText(selectEl) {
        return selectEl.options[selectEl.selectedIndex].text;
    }

    cashSubmitOrder =()=>{
        this.props.onSelectPay(this.state.list[0].configId);
    }

    icardSubmitOrder = (e)=>{
        let self = this;
        let $icardType = $(this.refs.icardtype);
        let $icardValue = $(this.refs.icardvalue);
        let type = $icardType.val().trim();
        let value = $icardValue.val().trim();
        let serial = $(this.refs.icardserial).val().trim();
        let code = $(this.refs.icardcode).val().trim();


        if (!serial) {
            new Notification({
                content: "Please enter serial of the card"
            }).create();
            return;
        }

        if (!code) {
            new Notification({
                content: "Please enter code of the card"
            }).create();
            return;
        }

        const contextProps = {
            type: this.getSelectedText($icardType[0]),
            value: this.getSelectedText($icardValue[0]),
            serial,
            code
        };

        Popup.create(contextProps, IcardConfirmDialog, function(status) {
            if (status === 'confirm') {
                self.props.onSelectPay(self.state.list[0].configId, {
                    cardType: type,
                    cardValue: value,
                    serial: serial,
                    code: code
                });
            }
        });
    }

    onChangeIcardType=(e)=>{
        let value = e.currentTarget.value;

        let [real, number] = this.props.list[0].proportion.split(':');

        if (value ==  1) {
            this.refs.icardvalue.value = '50000';

            this.setState({
                icardUD: 50000 * number / real
            });

            $(this.refs.icard20).addClass('hidden');
        } else {
            this.refs.icardvalue.value = '20000';

            this.setState({
                icardUD: 20000 * number / real
            });

            $(this.refs.icard20).removeClass('hidden');
        }
    }

    onChangeIcardValue=(e)=>{
        let value = e.currentTarget.value;

        let [real, number] = this.props.list[0].proportion.split(':');

        this.setState({
            icardUD: value * number / real
        });
    }

    render() {
        let list = this.state.list;
        let $list = [];

        list.forEach((item, index) => {
            $list.push(<Item key={index} data={item} onSelectPay={this.props.onSelectPay} />);
        });

        let channel = url.query('channel');

        if(channel === 'paystack') {
            $list = [];

            list.forEach((item, index) => {
                $list.push(<Item key={index} data={item} onSelectPay={ this.onPaystackSelectPay.bind(this) } />);
            });
        }

        if(channel === 'sslcommerz') {
            $list = [];

            list.forEach((item, index) => {
                $list.push(<Item key={index} data={item} onSelectPay={ this.onSslSelectPay.bind(this) } />);
            });
        }

        if (channel == 'icard') {
            let real, number, sybol;

            if (list[0]) {
                [real, number] = list[0].proportion.split(':');
                sybol = list[0].currencySymbol.toUpperCase();
            }
            return (
                <div className="recharge-icard">
                    <div className="cashrate">{lang.template('充值比例: <%=currence%><%=real%>=<%=number%>U钻', {real,currence:sybol,number})}</div>
                    <div className="item-wrap">
                    <label>{lang.template('icard_cardType')}:</label>
                        <div className="input-wrap">
                            <select ref="icardtype" onChange={this.onChangeIcardType}>
                                <option value="2">Mobifone</option>
                                <option value="1">Viettel</option>
                                <option value="3">Vinaphone</option>
                            </select>
                            <div className="expand-arrow"></div>
                        </div>
                    </div>
                    <div className="item-wrap">
                    <label>{lang.template('icard_cardValue')}:</label>
                        <div className="input-wrap">
                            <select ref="icardvalue" onChange={this.onChangeIcardValue}>
                                <option value="20000" ref="icard20">20.000</option>
                                <option value="50000">50.000</option>
                                <option value="100000">100.000</option>
                                <option value="200000">200.000</option>
                                <option value="500000">500.000</option>
                            </select>
                            <div className="expand-arrow"></div>
                        </div>
                    </div>
                    <div className="item-wrap">
                    <label>{lang.template('icard_Serial')}:</label>
                        <div className="input-wrap">
                    <input name="serial" ref="icardserial" type="text" placeholder={lang.template('icard_Please_enter_serial_of_the_card')}  autoComplete="off"/>
                        </div>
                    </div>
                    <div className="item-wrap">
                    <label>{lang.template('icard_Code')}:</label>
                        <div className="input-wrap">
                    <input name="code" ref="icardcode" type="text" placeholder={lang.template('icard_Please_enter_code_of_the_card')} autoComplete="off"/>
                        </div>
                    </div>
                    <div className="cashvalue">
                        { lang.template('<%=count%>U钻', { count: parseInt(this.state.icardUD, 10)})}
                    </div>
                    <div className="button" onClick={this.icardSubmitOrder}>{lang.template('立即充值')}</div>
                </div>
            )
        }

        // cashcard点卡充值，显示页面结构不同于其他渠道
        let cashcard;
        
        if (channel == 'cashcard_thb' || channel == 'pepay_entitycard_vnd' || channel == 'gash_card') {
            let real, number, sybol;
            if (list[0]) {
                [real, number] = list[0].proportion.split(':');
                sybol = list[0].currencySymbol.toUpperCase();
            }

            cashcard = (
                <div className="optionlist cashcard">
                    <span className="cashsub" onClick={this.cashSubmitOrder}>{lang.template('立即充值')}</span>
                    <div className="cashrate">{lang.template('充值比例: <%=currence%><%=real%>=<%=number%>U钻', {real,currence:sybol,number})}</div>
                    <div className="tips">{lang.template('小贴士')}</div>
                    <div className="spectip">
                        <p className="cash"><em>1.</em> {lang.template('使用CashCard充值的金额数以点卡实际支付的金额为准')}</p>
                        <p className="cash"><em>2.</em> {lang.template('使用CashCard充值所得U钻数将根据兑换比例c进行换算，最终所得U钻数会进行四舍五入处理', {real,currence:sybol,number})}</p>
                    </div>
                </div>
            );
        }

        if (cashcard) {
            return cashcard;
        }

        return (
            <div className="optionlist">
                {
                    url.query('channel') == 'twrecharge' ? (
                        <div className="recharge-type">
                            <div className="title" dangerouslySetInnerHTML={{__html:lang.template('充值金额')}}></div>
                        </div>
                    ) : null
                }
                <ul>
                    {$list}
                </ul>

                {
                    channelConfig.option == 'bj_mycard'  ? (
                        <div className="spectip">
                            <p>MyCard例行維護時間：每週一 上午08:00至09:30止；在此期間所有相關功能將暫停使用！請您耐心等候。</p>
                        </div>
                    ) : null
                }
            
                {
                    url.query('channel') == 'paystack' ?
                        (<PaystackConfirmModal onCompleted={ this.onPaystackConfirmed.bind(this) }/>) : null
                }

                {
                    url.query('channel') == 'sslcommerz' ?
                        (<SslConfirmModal onCompleted={ this.onSslConfirmed.bind(this) }/>) : null
                }
            </div>
        );
    }
};

export default OptionListView;



// WEBPACK FOOTER //
// ./js/orderview/option-list-view.js